module.exports = __webpack_public_path__ + "assets/img/6_515.0ee43817.jpg";